
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Calque 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 143"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.8 10.87a125.73 125.73 0 01103.58 123.76H10.72","fill":"#79787d"}}),_c('path',{attrs:{"d":"M64.52 138.35c2.56-74.15-51.86-82.69-51.86-82.69","fill":"none","stroke":"#fff","stroke-miterlimit":"5","stroke-width":"3","stroke-dasharray":"80"}})])
          )
        }
      }
    